import { createApi } from "@reduxjs/toolkit/query/react";
import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { baseQueryAdminWithAuth } from "../api";
import type { ListWorkerLogsRequest, ListWorkerLogsResponse } from "../../contracts";

export const adminWorkerLogApi = createApi({
    reducerPath: "adminWorkerLogApi",
    baseQuery: baseQueryAdminWithAuth,
    endpoints: builder => ({
        listWorkerLogs: builder.query<ListWorkerLogsResponse, ListWorkerLogsRequest>({
            query: body => ({
                url: `workerlog/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            })
        }),
        clearWorkerLog: builder.mutation<void, void>({
            query: () => ({
                url: "workerlog/clear",
                method: "POST"
            })
        })
    })
});

export const {
    useLazyListWorkerLogsQuery,
    useClearWorkerLogMutation
} = adminWorkerLogApi;
